import Keycloak from 'keycloak-js'

let _kc: Keycloak
let _interval
const refreshToken = () => _kc.updateToken(10)

export default {
  setKeycloak(keycloak: Keycloak) {
    _kc = keycloak

    if (_interval) clearInterval(_interval)
    _interval = setInterval(refreshToken, 1000)
  },

  fetch() {
    return _kc.token
  },

  getKeycloakInstance() {
    return _kc
  },
}
